import { log } from '@/lib/logger';
/**
 * Barrel re-export — preserves the exact public API of the original api.ts.
 * All consumer imports from '../lib/api' or '../../lib/api' continue to work.
 */

log.info('[api/index] Barrel module loaded');

// API objects
export { projectsApi } from './projects';
export { ticketsApi } from './tickets';
export { issuesApi } from './issues';
export { figmaApi } from './figma';
export { integrationsApi } from './integrations';
export { aiApi } from './ai';
export { teamsApi } from './teams';
export { teamJoinRequestsApi } from './teamJoinRequests';
export type { JoinCandidate, JoinCandidatesResponse, PendingJoinRequest } from './teamJoinRequests';
export { authApi } from './auth';
export { uploadApi } from './upload';
export { onboardingApi } from './onboarding';
export { accountApi } from './account';
export { dashboardApi } from './dashboard';
export { usersApi } from './users';
export { betaInvitesApi } from './betaInvites';
export type { BetaInviteLookup, BetaRedeemResult } from './betaInvites';
export { projectSharesApi } from './projectShares';
export type { ProjectShare } from './projectShares';
export { a11yIgnoredDashboardApi } from './a11yIgnored';
export { helpAgentApi } from './helpAgent';
export { configApi } from './config';
export { deletionImpactApi } from './deletionImpact';

// Types
export type { ProjectWithPreview } from './projects';
export type { HelpChatInput, HelpChatResponse } from './helpAgent';

// Re-export shared types that the original file re-exported for consumers
export type {
  Integration,
  JiraProject,
  JiraIssueType,
  LinearTeam,
  LinearLabel,
  ExportResult,
  AISuggestion,
} from '@overlayqa/shared';
